import { createStyles, makeStyles } from "@material-ui/core";
import { UIKIT_COLORS } from "../../theme/colors";

export const useStyles = makeStyles(() =>
  createStyles({
    base: {
      fontFamily: "'Montserrat', sans-serif",
    },
    // ── Preset text styles used across the kit ────────────────────────────
    fieldLabel: {
      fontFamily: "'Montserrat', sans-serif",
      fontSize: 12,
      fontWeight: 500,
      color: UIKIT_COLORS.TEXT_MUTED,
      letterSpacing: "0.3px",
      textTransform: "uppercase",
      lineHeight: "16px",
    },
    fieldValue: {
      fontFamily: "'Montserrat', sans-serif",
      fontSize: 14,
      fontWeight: 600,
      color: UIKIT_COLORS.TEXT_PRIMARY,
      lineHeight: "20px",
    },
    sectionTitle: {
      fontFamily: "'Montserrat', sans-serif",
      fontSize: 16,
      fontWeight: 600,
      color: UIKIT_COLORS.TEXT_PRIMARY,
      lineHeight: "24px",
    },
    sectionSubtitle: {
      fontFamily: "'Montserrat', sans-serif",
      fontSize: 12,
      fontWeight: 400,
      color: UIKIT_COLORS.TEXT_SECONDARY,
      lineHeight: "16px",
    },
    panelTitle: {
      fontFamily: "'Montserrat', sans-serif",
      fontSize: 20,
      fontWeight: 700,
      color: UIKIT_COLORS.TEXT_PRIMARY,
      lineHeight: "28px",
    },
    caption: {
      fontFamily: "'Montserrat', sans-serif",
      fontSize: 11,
      fontWeight: 500,
      color: UIKIT_COLORS.TEXT_SECONDARY,
    },
  })
);
